<template>
  <div class="header">
    <div class="w navi flex" style="justify-content: space-between">
      <img style="height: 48px;" :src="imgPrefix + findTopBar.logoColor" alt="" />
      <div class="flex" style="justify-content: space-between; width: 50%">
        <div
          :class="index == naviIndex ? 'line_class' : ''"
          v-for="(item, index) in naviArr"
          :key="index"
          @click="changeUrl(item.link, index, item)"
        >
          {{ item.name }}
        </div>
        <template v-if="userId">
           <a-dropdown>
             <a class="ant-dropdown-link" @click="e => e.preventDefault()">
               {{supUserName}}<a-icon type="down" />
             </a>
             <a-menu slot="overlay">
               <a-menu-item>
                 <a href="javascript:;" style="color: #2c3e50;" @click.stop="logout">退出登录</a>
               </a-menu-item>
             </a-menu>
           </a-dropdown>
        </template>
            <div v-else class="login_class" @click.stop="loginFn">登录</div>
      </div>
    </div>
  </div>
</template>

<script>
import imgPrefix from "../../utils/imgPrefix";
import { findNavApi, findTopBarApi,logout } from "../api/index";
export default {
  data() {
    return {
      // "首页", "主题专区", "服务大厅", "三张清单"
      naviArr: [],
      newNaviArr: [],
      history: ["一卡通", "请假", "奖助学金"],
      naviIndex: "-1",
      naviId: "",
      findTopBar: {},
      imgPrefix,
      userId:'',
      supUserName:'',
    };
  },
  // 监听,当路由发生变化的时候执行
  watch: {
    $route(to, from) {
      let naviId = sessionStorage.getItem("naviId");
      this.naviId = this.$route.query.naviId
        ? this.$route.query.naviId
        : naviId;
      if(this.naviArr.length>0){
        this.naviArr.forEach((item, idx) => {
        if (item.id == this.naviId) {
          this.naviIndex = idx;
        }
      });
      }
    },
  },
  created() {
    // 获取登录后的userId
    this.userId = localStorage.getItem('userId');
    // 获取登录信息
    let info = localStorage.getItem('ly-portal-affairs-ui-userLogin');
    if(localStorage.getItem('ly-portal-affairs-ui-userLogin')){
      info = JSON.parse(info)
      // console.log(info);
      this.supUserName = info?.userName;
    }
    // 获取顶部导航
    findNavApi().then((res) => {
      // console.log(res);
      this.newNaviArr = res;
      this.naviArr = res.filter((item) => {
        return item.status == "1";
      });
      let naviId = sessionStorage.getItem("naviId");
      this.naviId = this.$route.query.naviId
        ? this.$route.query.naviId
        : naviId;
      this.naviArr.forEach((item, idx) => {
        if (item.id == this.naviId) {
          this.naviIndex = idx;
        }
      });
    });
    this.findTopBar = JSON.parse(sessionStorage.getItem("findTopBar"));
    // 获取顶部栏基本信息
    findTopBarApi().then((res) => {
      // console.log(res);
      this.findTopBar = res;
      document.title = res.sysName;
      // 改变主题颜色
      const bodyStyle = document.getElementsByTagName("body")[0].style;
      bodyStyle.setProperty("--themeColor", res.topicColor);
      // 改变网站图标
      var link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = this.imgPrefix + res.webInco;
      document.getElementsByTagName("head")[0].appendChild(link);
      sessionStorage.setItem("findTopBar", JSON.stringify(res));
    });
  },
  methods: {
    loginFn() {
      // window.open("https://portal.ly-sky.com:7435/swzx/#/login");
      // this.$router.push('/login')
      window.open('http://chall.gdufe.edu.cn/qzqdht/')
    },
    gotoPage(e) {
      window.open(e);
    },
    changeUrl(url, idx, val) {
      // this.$router.push(e);
      this.naviIndex = idx;
      sessionStorage.setItem("naviId", val.id);
      if(val.classify == 1){
        this.$router.push(`${url}?naviId=${val.id}`);
      }else{
        window.open(url)
      }
    },
    logout() {
      let that = this;
      this.$confirm({
        title: "确认退出登录么？",
        okText: "确认",
        cancelText: "取消",
        onOk() {
          // sessionStorage.removeItem("accessToken");
          // that.$router.push('/login')
          // console.log(global.userId);
          // console.log(global.tokenId);
          // console.log(global.orgId);
          let headers = {
            // "userAuthType": "MS"
            'X-Requested-With': 'XMLHttpRequest',
            'gatewayAppId': 'ly-portal-affairs',
            'gatewayserviceid': 'ly-portal-affairs-svc',
            'Authorization': global.tokenId,
            'Loginuserid': global.userId,
            'Loginuserorgid': global.orgId
          }
          logout('', headers).then(e => {
            // console.log('e', e);
          }).catch(res => {
            // console.log(res);
            sessionStorage.clear();
            that.$message.success('登出成功！');
            setTimeout(() => {
              that.$router.push('/login')
            }, 500);
            // window.location = window.casLogoutUrl;
          })
        }
      })

    },
  },
};
</script>

<style lang="less" scoped>
.header {
  .top {
    justify-content: space-between;
    // padding-top: 24px;
    margin-bottom: 33px;
    .top_head {
      color: #555555;
      font-size: 14px;
      .top_head_box {
        padding: 0 32px;
        position: relative;
        cursor: pointer;
      }
      .pseudo_class::after {
        content: "";
        position: absolute;
        top: 20%;
        right: -3%;
        width: 1px;
        height: 14px;
        background: #555;
        opacity: 0.5;
      }
    }
  }
  .navi {
    div {
      height: 88px;
      line-height: 88px;
      // margin-right: 67px;
      font-size: 16px;
      cursor: pointer;
      position: relative;
      position: relative;
    }
    .line_class {
      color: var(--themeColor);
    }
    .line_class::after {
      content: "";
      position: absolute;
      bottom: 16px;
      left: 0;
      width: 100%;
      height: 2px;
      background: var(--themeColor);
    }
    .login_class {
      background: rgba(255, 255, 255, 0.2);
      padding: 0 12px;
      border-radius: 4px;
    }
  }
  .navi div:last-child {
    margin-right: 0;
  }
}
.ant-dropdown-link{
  color: #2c3e50;
  height: 30px;
  line-height: 30px;
}
</style>
